import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.css']
})
export class ConfirmPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
   }
//   submit() {
//     //alert('Mail sent');
//       alert('An email has been sent to your address with a reset password you can use to access your account.');
//   }

}



// WEBPACK FOOTER //
// ./src/app/confirm-password/confirm-password.component.ts